import React from 'react';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';
import StaticPageLayout from '../components/layout/StaticPageLayout';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
    return (
        <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <SEO title="Privacy Policy" description="RMT privacy policy. Learn how we collect, use, and protect your personal information when you use our vehicle tag renewal service." canonical="/privacy/policy" />
            <Header />
            <StaticPageLayout
                title="Privacy Policy"
                subtitle="At Renew My Tech (RMT), we respect your privacy and are committed to protecting your personal information."
            >
                <div className="tw-prose tw-prose-gray tw-max-w-none">
                    <h3 className="tw-text-xl tw-text-gray-900 tw-mt-0">1. Information We Collect</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        At Renew My Tech (RMT), we collect certain types of information from our users, including but not limited to personal information such as name, email address, phone number, and payment details. We collect this information to provide and improve our services.
                    </p>

                    <h3 className="tw-text-xl tw-text-gray-900">2. How We Use Your Information</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        We use the collected information to process transactions with government entities on behalf of the consumer and provide customer support. We may also use the information to send notifications and updates related to our services.
                    </p>

                    <h3 className="tw-text-xl tw-text-gray-900">3. Sharing Your Information</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        RMT takes your privacy seriously. We do not sell or rent your personal information to third parties. However, we may share your information with trusted partners and service providers to facilitate the services we offer.
                    </p>

                    <h3 className="tw-text-xl tw-text-gray-900">4. Notification and Charges</h3>
                    <ul className="tw-text-sm tw-text-gray-600 tw-leading-relaxed tw-space-y-2">
                        <li>Users who subscribe to our automated car tag service(s) will receive notifications by text and email regarding upcoming charges. Notifications will be sent 30 days prior to the charge, 15 days prior to the charge, 10 days prior to the charge, and 3 days prior to the charge.</li>
                        <li>If a user receives a notification and does not respond or cancel the service within 3 days of the scheduled charge, it will be considered as their approval, and we will proceed to charge them as agreed upon.</li>
                        <li>If the payment method on-file is insufficient or results in a chargeback, the subscriber will be responsible for all related fees. Fees will be at the cost of fees incurred by RMT and nothing more.</li>
                    </ul>

                    <h3 className="tw-text-xl tw-text-gray-900">5. Security</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        We employ industry-standard security measures to protect your personal information from unauthorized access, disclosure, or alteration. Your data is important to us, and we take all necessary precautions to keep it safe.
                    </p>

                    <h3 className="tw-text-xl tw-text-gray-900">6. Your Choices</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        You have the choice to manage your subscription and personal information. You can cancel your subscription at any time by following the provided instructions. If you have any questions or concerns about your information, please contact us.
                    </p>

                    <h3 className="tw-text-xl tw-text-gray-900">7. Changes to This Privacy Policy</h3>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                        RMT may update this Privacy Policy from time to time to reflect changes in our services and practices. We will notify users of any significant changes to this policy.
                    </p>
                </div>
            </StaticPageLayout>
            <PublicFooter />
        </div>
    );
};

export default PrivacyPolicy;
